import { useCallback, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  clearCart,
  removeItemFromCart,
  reduceItemFromCart,
  increaseItemInCart,
  changeActiveCart,
} from "../../../../redux/cart";
import LoadingScreen from "../../../UI/LoadingScreen/LoadingScreen";
// import MessageBox from "../../../UI/MessageBox/MessageBox";
import IconButton from "../../../UI/IconButton/IconButton";
import CartTypeButton from "./CartTypeButton/CartTypeButton";
import Payment from "./Payment/Payment";
import PriceListItem from "./PriceListItem/PriceListItem";
import { AuthContext } from "../../../../context/authContext";
import classes from "./Cart.module.scss";
import axios from "../../../../config/axiosWithLocation";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useTranslation } from "react-i18next";

const Cart = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cartState = useSelector((state) => state.cart);
  const finalOrder = useSelector((state) => state.finalOrder);
  const { selectedLocation } = useSelector((state) => state.location);
  const { loggedInUser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  // const [message, setMessage] = useState(null);
  const selectedCartType = `${cartState.activeCart
    .toLocaleLowerCase()
    .replace(" ", "")}Items`;

  const radioChangeHandler = (newValue) => {
    dispatch(changeActiveCart(newValue));
  };

  const removeDishFromCart = (index) => {
    dispatch(removeItemFromCart(index));
  };

  const getSubTotalPrice = () => {
    let subTotalPrice = 0;

    for (const item of cartState[selectedCartType]) {
      subTotalPrice += +item.price * item.quantity;
    }
    return subTotalPrice;
  };

  const getTotalTax = () => {
    return getSubTotalPrice() * 0.15;
  };

  const getTotalPrice = () => {
    let totalPrice = 0;
    totalPrice += getSubTotalPrice();
    totalPrice += getTotalTax();

    return totalPrice;
  };

  const onReduceItemQuantity = (itemId) => {
    dispatch(reduceItemFromCart(itemId));
  };

  const onIncreaseItemQuantity = (itemId) => {
    dispatch(increaseItemInCart(itemId));
  };

  const handleError = useCallback((err) => {
    setIsLoading(false);
    if (
      err.response.data &&
      err.response.data.message &&
      typeof err.response.data.message === "object"
    ) {
      for (let errorKey of Object.keys(err.response.data.message)) {
        toast.error(err.response.data.message[errorKey][0], {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } else if (
      err.response.data &&
      err.response.data.message &&
      typeof err.response.data.message === "string"
    ) {
      toast.error(err.response.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    setIsLoading(false);
  }, []);

  const placeOrder = () => {
    // navigate("/orders/checkout");
    setIsLoading(true);
    // setMessage(null);
    let order = {
      restaurant_id: loggedInUser.restaurant_id,
      orders: [...cartState[selectedCartType]],
      location_id: selectedLocation,
      type: cartState.activeCart.replace(/[A-Z]/g, " $&").toLocaleLowerCase(),
    };


    axios

      .post("/order_details", order)
      .then((res) => {
        props.onClear();
        dispatch(clearCart());
        toast.success("Order placed successfully!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setIsLoading(false);
        // return res;
      })
      // .then((placedOrderResponse) => {
      //   let completingOrder = {
      //     restaurant_id: loggedInUser.restaurant_id,
      //     order_id: placedOrderResponse.data.order_id,
      //     status: "complete",
      //     order_no: placedOrderResponse.data.order_no,
      //   };

      //   axios
      //     .post("/order/status", completingOrder)
      //     .then((res) => {
      //       props.onClear();
      //       dispatch(clearCart());
      //       toast.success("Order placed successfully!", {
      //         position: toast.POSITION.BOTTOM_RIGHT,
      //       });
      //       setIsLoading(false);
      //     })
      //     .catch((err) => {
      //       handleError(err);
      //     });
      // })
      .catch((err) => {
        handleError(err);
      });
  };

  return (
    <div className={classes.Cart}>
      <ToastContainer />
      <LoadingScreen show={isLoading} />
      <div className={classes.CartTypeButtons}>

        <div className={classes.ActionButtons}>
          {finalOrder.orderTypes.map((type) => {
            return (
              <CartTypeButton
                key={type}
                text={type.replace(/([A-Z])/g, " $1").trim()}
                value={type}
                name="cartType"
                isChecked={cartState.activeCart === type}
                onChanged={radioChangeHandler}
              />
            );
          })}
        </div>

        <IconButton
          icon="plus"
          iconPosition="left"
          customClasses="ml-auto"
          text={t("BTN_ADD_SERVICES")}
          type="secondary"
          onClicked={() => navigate("/home/new-order")}
        />
      </div>
      <div className={classes.PriceList}>
        {cartState[selectedCartType].map((item, index) => {
          return (
            <PriceListItem
              key={Math.random(100)}
              id={index + 1}
              name={item.item_name}
              quantity={item.quantity}
              price={item.price}
              onRemove={removeDishFromCart}
              onReduceItemQuantity={onReduceItemQuantity}
              onIncreaseItemQuantity={onIncreaseItemQuantity}
            />
          );
        })}
      </div>
      <div className={classes.CouponTab}>
        <span className={classes.CouponText}>{t("ADD")}</span>
        <button className={classes.CouponButton}>{t("DISCOUNT")}</button>
        <button className={classes.CouponButton}>{t("COUPON_CODE")}</button>
        <button className={classes.CouponButton}>{t("CODE")}</button>
      </div>
      <div className={classes.PaymentTab}>
        <Payment text={t("SUBTOTAL")} price={getSubTotalPrice()} />
        <Payment text={t("TAX")} price={getTotalTax()} />
        <Payment
          text={t("PAYABLE_AMOUNT")}
          price={getTotalPrice()}
          size="large"
        />
      </div>
      <div className={classes.CheckoutButtons}>
        <IconButton
          icon="pause"
          iconPosition="right"
          text={t("HOLD_CART")}
          size="big"
          type="secondary"
          onClicked={() => console.log("clicked")}
        />
        <IconButton
          icon="arrow-right"
          iconPosition="right"
          text={t("PROCEED")}
          size="big"
          onClicked={placeOrder}
          disabled={cartState[selectedCartType].length === 0}
        />
      </div>
    </div>
  );
};

export default Cart;
